<template>
  <div class="pageRoot linkListPage authManagePage">
    <div class="pageShell">
      <div class="pageShell__main">
        <div class="pageShell__scroll">
          <div class="listWorkspace">
            <section class="filterCard filterAnchor">
              <auth-manage-list-filter-panel
                v-bind="filterPanelProps"
                v-on="filterPanelListeners"
              />
            </section>

            <section class="tableCard tableZone">
              <div v-if="!loading && tableData.length" class="tableSection">
                <el-table
                  ref="multipleTable"
                  class="linkTable linkTable--hybrid authManageTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  row-key="id"
                  @row-click="handleRowClick"
                >
                  <el-table-column type="expand" width="56">
                    <template slot-scope="props">
                      <div class="authExpandPanel">
                        <div
                          v-if="getResourceMenuGroup(props.row.menuList)"
                          class="authExpandPanel__block authExpandPanel__block--resource"
                        >
                          <h3 class="authExpandPanel__groupTitle">资源管理</h3>
                          <div class="authExpandPanel__resourceCols">
                            <div
                              v-for="(column, colIndex) in getResourceMenuColumns(
                                props.row.menuList
                              )"
                              :key="'resource-col-' + colIndex"
                              class="authExpandPanel__resourceCol"
                            >
                              <div
                                v-for="item in column"
                                :key="item.menuId"
                                class="authExpandPanel__row authExpandPanel__row--resource"
                              >
                                <span class="authExpandPanel__menuName">{{ item.name }}</span>
                                <el-radio-group
                                  class="authExpandPanel__radios"
                                  :disabled="$route.meta.role !== 2"
                                  v-model.number="item.role"
                                  @change="updateRole(item.userId, item.menuId, item.role)"
                                  @click.native.stop
                                >
                                  <el-radio :label="0">无权限</el-radio>
                                  <el-radio :label="1">查看权限</el-radio>
                                  <el-radio :label="2">编辑权限</el-radio>
                                </el-radio-group>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="authExpandPanel__rest">
                          <div
                            v-for="menuItem in getOtherMenuGroups(props.row.menuList)"
                            :key="menuItem.id || menuItem.name"
                            class="authExpandPanel__block authExpandPanel__block--section"
                          >
                            <h3 class="authExpandPanel__groupTitle">{{ menuItem.name }}</h3>
                            <div class="authExpandPanel__list authExpandPanel__list--inline">
                              <div
                                v-for="item in menuItem.children"
                                :key="item.menuId"
                                class="authExpandPanel__row"
                              >
                                <span class="authExpandPanel__menuName">{{ item.name }}</span>
                                <el-radio-group
                                  class="authExpandPanel__radios"
                                  :disabled="$route.meta.role !== 2"
                                  v-model.number="item.role"
                                  @change="updateRole(item.userId, item.menuId, item.role)"
                                  @click.native.stop
                                >
                                  <el-radio :label="0">无权限</el-radio>
                                  <el-radio :label="1">查看权限</el-radio>
                                  <el-radio :label="2">编辑权限</el-radio>
                                </el-radio-group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="用户名"
                    prop="userName"
                    align="left"
                    header-align="left"
                    min-width="160"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    label="邮箱"
                    prop="mail"
                    align="left"
                    header-align="left"
                    min-width="240"
                    show-overflow-tooltip
                  />
                </el-table>
              </div>

              <div v-else-if="!loading && !tableData.length" class="tableEmpty">
                <div class="tableEmpty__icon"><i class="el-icon-user" /></div>
                <p class="tableEmpty__title">暂无账号记录</p>
                <p class="tableEmpty__desc">调整筛选条件，或新增 CMS 用户。</p>
                <el-button
                  type="primary"
                  size="small"
                  class="actionButton actionButtonQuery"
                  icon="el-icon-plus"
                  v-check-role
                  @click="dialogOpen"
                >
                  新增用户
                </el-button>
              </div>

              <div v-else class="tableSkeletonWrap">
                <el-skeleton :rows="8" animated />
              </div>
            </section>
          </div>
        </div>
      </div>

      <div class="pageShell__footer tableCard__footer footerBar">
        <div class="footerSummary">
          共 <strong class="footerSummary__count">{{ listTotalCount }}</strong> 条 · 第
          {{ currentPage }} / {{ totalPages }} 页
        </div>
        <el-pagination
          class="linkPagination"
          layout="prev, pager, next, sizes, jumper"
          :total="listTotalCount"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="currentPageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog
      title="创建用户"
      :visible.sync="dialogVisible"
      :before-close="beforeClose"
      width="440px"
      custom-class="linkUploadDialog authCreateDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
      >
        <el-form-item label="邮箱" prop="mail">
          <el-input
            type="text"
            :readonly="readonly"
            v-model="ruleForm.mail"
            placeholder="邮箱号"
          />
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input
            type="text"
            :readonly="readonly"
            v-model="ruleForm.userName"
            placeholder="用户名"
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            :readonly="readonly"
            v-model="ruleForm.password"
            placeholder="默认密码（xinmei365）"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          class="actionButton actionButtonQuery"
          type="primary"
          style="width: 100%"
          @click="submit"
        >
          注册
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { register, getUserMenu, updateUserMenu } from '../../../api/auth'
import AuthManageListFilterPanel from './AuthManageListFilterPanel.vue'

export default {
  name: 'AuthManageIndex',
  components: {
    AuthManageListFilterPanel,
  },
  data() {
    return {
      userName: '',
      tableData: [],
      currentPage: 1,
      currentPageSize: 10,
      total: 0,
      loading: false,
      ruleForm: {},
      rules: {
        mail: [
          { required: true, message: '请输入邮箱号', trigger: 'blur' },
          { type: 'email', message: '请输入有效的邮箱号', trigger: 'blur' },
        ],
        password: [
          { min: 8, max: 15, message: '密码长度应为8-15位', trigger: 'blur' },
        ],
      },
      dialogVisible: false,
      readonly: true,
    }
  },
  computed: {
    listTotalCount() {
      const parsed = Number(this.total)
      return Number.isFinite(parsed) ? parsed : 0
    },
    totalPages() {
      if (this.listTotalCount === 0) return 1
      return Math.max(1, Math.ceil(this.listTotalCount / this.currentPageSize))
    },
    activeFilterCount() {
      return String(this.userName || '').trim() ? 1 : 0
    },
    filterPanelProps() {
      return {
        userName: this.userName,
        activeFilterCount: this.activeFilterCount,
        panelTotalCount: this.listTotalCount,
      }
    },
    filterPanelListeners() {
      return {
        search: this.search,
        'reset-filters': this.resetFilters,
        'reset-and-search': this.resetAndSearch,
        'create-user': this.dialogOpen,
        'update:userName': (value) => {
          this.userName = value
        },
      }
    },
  },
  created() {
    this.getList()
  },
  methods: {
    /** 展开区模块顺序：资源 → 集合 → 解锁 → 渠道 → 其余按后端 sort */
    getMenuGroupOrderRank(name) {
      const order = ['资源管理', '集合管理', '解锁管理', '渠道管理']
      const index = order.indexOf(name)
      return index === -1 ? 100 + order.length : index
    },
    getResourceMenuGroup(menuList) {
      return (menuList || []).find((item) => item.name === '资源管理') || null
    },
    getResourceMenuColumns(menuList) {
      const children = (this.getResourceMenuGroup(menuList)?.children) || []
      if (!children.length) return [[], [], []]
      const perCol = Math.ceil(children.length / 3)
      return [
        children.slice(0, perCol),
        children.slice(perCol, perCol * 2),
        children.slice(perCol * 2),
      ]
    },
    getOtherMenuGroups(menuList) {
      return [...(menuList || [])]
        .filter((item) => item.name !== '资源管理')
        .sort((a, b) => {
          const rankDiff =
            this.getMenuGroupOrderRank(a.name) - this.getMenuGroupOrderRank(b.name)
          if (rankDiff !== 0) return rankDiff
          const sortA = Number(a.sort)
          const sortB = Number(b.sort)
          if (Number.isFinite(sortA) && Number.isFinite(sortB) && sortA !== sortB) {
            return sortA - sortB
          }
          return String(a.name || '').localeCompare(String(b.name || ''), 'zh-CN')
        })
    },
    handleRowClick(row, column, event) {
      const target = event && event.target
      if (!target) return
      if (target.closest('.el-table__expand-column')) return
      this.$refs.multipleTable.toggleRowExpansion(row)
    },
    beforeClose() {
      this.$refs.ruleForm.resetFields()
      this.dialogVisible = false
    },
    updateRole(userId, menuId, role) {
      updateUserMenu({ userId, menuId, role })
        .then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '权限修改成功',
            })
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err,
            showClose: true,
            duration: 5000,
          })
        })
    },
    getList() {
      this.loading = true
      getUserMenu({
        pageNum: this.currentPage,
        pageSize: this.currentPageSize,
        userName: this.userName,
      })
        .then((res) => {
          if (res.success) {
            this.total = res.data.total
            this.tableData = res.data.list
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    search() {
      this.currentPage = 1
      this.getList()
    },
    resetFilters() {
      this.userName = ''
    },
    resetAndSearch() {
      this.resetFilters()
      this.search()
    },
    handleSizeChange(val) {
      this.currentPageSize = val
      this.$nextTick(() => {
        this.getList()
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    dialogOpen() {
      this.dialogVisible = true
      setTimeout(() => {
        this.readonly = false
      }, 1000)
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message({
            type: 'info',
            message: '您还有表单没填完整！',
          })
          return false
        }
        register(this.ruleForm)
          .then((res) => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '注册成功',
              })
              this.dialogVisible = false
              this.getList()
            } else {
              this.$message({
                type: 'info',
                message: res.errMessage,
              })
            }
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: err,
              duration: 5000,
              showClose: true,
            })
          })
      })
    },
  },
}
</script>
